const type = 'OPEN_CARD_UNBLOCK';

const openCardUnblock = () => ({
  type,
});

export { type };
export default openCardUnblock;
